import React from "react";

const CINEPlay = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M0 0V16L16 8L0 0Z" fill={color} />
    </svg>
  );
};

export default CINEPlay;
